import * as React from 'react';
import { connect } from 'react-redux';
import {
    Modal,
    Button,
    FormControl,
    FormGroup,
    ControlLabel,
    HelpBlock,
    Tab,
    Nav,
    NavItem,
    Checkbox,
    Table
} from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import * as BrokerChainActions from '../actions/BrokerChainActions';
import * as BrokerTreeTypes from '../BrokerTreeTypes';
import { assign } from '../../../shared/Assign';
import notify from '../../../shared/feedback/notifications';
import { handleError } from '../../../shared/ErrorCatching';
import FormInputChangeHandler from '../../../shared/form/FormInputChangeHandler';
import FormValidationService from '../../../shared/form/FormValidationService';
import ProductList from '../products/ProductList';
import FormSelect from '../../../components/common/FormSelect';
import Integrations from './Integrations';
import ShowcaseSettings from "../firm/ShowcaseSettings";
import BrokersApi from "../BrokersApi";
import * as Features from '../../../shared/Features';
import {
    CustomerAgreementTab,
    CustomerAgreementTabHandle
} from '../customerAgreements/CustomerAgreementTab';

class ChainModal extends React.Component<any, any> {
    formInputChangeHandler: FormInputChangeHandler;

    customerAgreementTab = React.createRef<CustomerAgreementTabHandle>();


    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            chain: {
                type: BrokerTreeTypes.Chain,
                parentId: props.item.parentId,
                products: [],
                name: '',
                highImageSize: 0,
                highImageDpi: 0,
                normalImageSize: undefined,
                normalImageDpi: undefined,
                normalImageAutoScale: undefined,
                normalImageSizeActive: false,
                profileColor: '',
                profileLogo: ''
            },
            image: {},
            imagePreviewUrl: '',
            errors: [],
            creating: false
        };

        this.closeModal = this.closeModal.bind(this);
        this.save = this.save.bind(this);
        this.setChainState = this.setChainState.bind(this);
        this.updateProducts = this.updateProducts.bind(this);
        this.updateArchiveSource = this.updateArchiveSource.bind(this);
        this.handleLogoChange = this.handleLogoChange.bind(this);
        this.updateProfileColor = this.updateProfileColor.bind(this);
        this.formInputChangeHandler = new FormInputChangeHandler(
            this.state.chain,
            this.setChainState
        );
    }
    handleLogoChange = (file) => {
        if (file) {
            let reader = new FileReader();
            reader.onloadend = () => {
                let chain = assign({}, this.state.chain);
                chain.profileLogo = file;
                this.setState({profileLogo: file}, () => {
                })
                this.formInputChangeHandler.updateObj(chain);
                this.setChainState(chain);
                let image = file;
                image.data = reader.result;
                this.setState({image: image});
                BrokersApi.uploadBrokerChainFile(this.state.chain.id, this.state.image)
            };
            reader.readAsArrayBuffer(file);
            let dataUrlreader = new FileReader();
            dataUrlreader.onloadend = () => {
                this.setState({imagePreviewUrl: dataUrlreader.result})
            };
            dataUrlreader.readAsDataURL(file);
        } else {
            let chain = assign({}, this.state.chain);
            chain.profileLogo = file;
            this.setState({profileLogo: null}, () => {
            })
            this.setState({image: null});
            this.setState({imagePreviewUrl: null})
            this.formInputChangeHandler.updateObj(chain);
            this.setChainState(chain);
        }
    }
    setChainState(newChain: any) {
        this.setState({ chain: newChain });
    }

    componentDidMount() {
        if (this.props.item.id > 0) {
            this.props.actions
                .editBrokerChain(this.props.item.id)
                .then(() => {
                    let chain = assign({}, this.props.chain);
                    this.formInputChangeHandler.updateObj(chain);
                    this.setChainState(chain);
                })
                .catch((error: any) => {
                    notify.failure(error);
                });
        } else {
            this.props.actions
                .newBrokerChain()
                .then(() => {
                    let chain = assign({}, this.props.chain);
                    chain.products = this.props.products;
                    this.formInputChangeHandler.updateObj(chain);
                    this.setChainState(chain);
                })
                .catch((error: any) => {
                    notify.failure(error);
                });
        }
    }
    updateProfileColor(profileColor: string) {
        let chain = assign({}, this.state.chain);
        chain.profileColor = profileColor;
        this.formInputChangeHandler.updateObj(chain);
        this.setChainState(chain);
    }
    render() {
        const showCustomerAgreement =
            FormValidationService.isEdit(this.props.item.id) &&
            Features.hasAnyFeature(
                [Features.ViewAssignedCustomerAgreements, Features.AssignCustomerAgreements],
                this.props.user
            );

        return (
            <Modal show={true} onHide={this.closeModal} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {FormValidationService.isEdit(this.props.item.id)
                            ? Translate('broker-chain/form/edit/title') +
                              (this.state.chain.name ? ': ' : '') +
                              this.state.chain.name
                            : Translate('broker-chain/form/create/title')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tab.Container defaultActiveKey={1} id="uncontrolled-tab">
                        <div>
                            <Nav>
                                <NavItem eventKey={1}>
                                    {Translate('broker-chain/form/tab/information')}
                                    {FormValidationService.setTabValidationError(
                                        this.state.errors,
                                        'name',
                                        'internalInformation',
                                        'photographerInformation',
                                        'deliveryWarning',
                                        'imageEditingInformation',
                                        'editStyleId'
                                    )}
                                </NavItem>
                                <NavItem eventKey={2}>
                                    {Translate('broker-chain/form/tab/image-size')}
                                    {FormValidationService.setTabValidationError(
                                        this.state.errors,
                                        'highImageSize',
                                        'highImageDpi',
                                        'highImageAutoScale',
                                        'normalImageSize',
                                        'normalImageDpi',
                                        'normalImageAutoScale'
                                    )}
                                </NavItem>
                                <NavItem eventKey={3}>
                                    {Translate('broker-chain/form/tab/product-allocations')}
                                </NavItem>
                                <NavItem eventKey={4}>
                                    {Translate('broker-chain/form/tab/integration')}
                                    {FormValidationService.setTabValidationError(
                                        this.state.errors,
                                        'archiveSource'
                                    )}
                                </NavItem>
                                <NavItem eventKey={5}>
                                    {Translate('broker-firm/form/tab/showcase')}
                                </NavItem>
                                {showCustomerAgreement && (
                                    <NavItem eventKey={6}>
                                        {Translate('broker-chain/form/tab/customer-agreement')}
                                    </NavItem>
                                )}
                            </Nav>
                            <Tab.Content>
                                <Tab.Pane eventKey={1}>
                                    <fieldset>
                                        <legend>
                                            {Translate('broker-chain/form/tab/information')}
                                        </legend>
                                        <FormGroup
                                            className="required"
                                            validationState={FormValidationService.getValidationState(
                                                this.state.errors.name
                                            )}
                                        >
                                            <ControlLabel>
                                                {Translate('broker-chain/form/name')}
                                            </ControlLabel>
                                            <FormControl
                                                autoFocus
                                                type="text"
                                                name="name"
                                                value={
                                                    this.state.chain.name
                                                        ? this.state.chain.name
                                                        : ''
                                                }
                                                onChange={this.formInputChangeHandler.onChange}
                                            />
                                            <HelpBlock>{this.state.errors.name}</HelpBlock>
                                        </FormGroup>
                                        <FormGroup>
                                            <ControlLabel>
                                                {Translate(
                                                    'broker-chain/form/internal-information'
                                                )}
                                            </ControlLabel>
                                            <FormControl
                                                componentClass="textarea"
                                                name="internalInformation"
                                                value={
                                                    this.state.chain.internalInformation
                                                        ? this.state.chain.internalInformation
                                                        : ''
                                                }
                                                onChange={this.formInputChangeHandler.onChange}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <ControlLabel>
                                                {Translate(
                                                    'broker-chain/form/photographer-information'
                                                )}
                                            </ControlLabel>
                                            <FormControl
                                                componentClass="textarea"
                                                name="photographerInformation"
                                                value={
                                                    this.state.chain.photographerInformation
                                                        ? this.state.chain.photographerInformation
                                                        : ''
                                                }
                                                onChange={this.formInputChangeHandler.onChange}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <ControlLabel>
                                                {Translate('broker-chain/form/delivery-warning')}
                                            </ControlLabel>
                                            <FormControl
                                                componentClass="textarea"
                                                name="deliveryWarning"
                                                value={
                                                    this.state.chain.deliveryWarning
                                                        ? this.state.chain.deliveryWarning
                                                        : ''
                                                }
                                                onChange={this.formInputChangeHandler.onChange}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <ControlLabel>
                                                {Translate(
                                                    'broker-chain/form/image-editing-information'
                                                )}
                                            </ControlLabel>
                                            <FormControl
                                                componentClass="textarea"
                                                name="imageEditingInformation"
                                                value={
                                                    this.state.chain.imageEditingInformation
                                                        ? this.state.chain.imageEditingInformation
                                                        : ''
                                                }
                                                onChange={this.formInputChangeHandler.onChange}
                                            />
                                        </FormGroup>

                                        <FormGroup
                                            validationState={FormValidationService.getValidationState(
                                                this.state.errors.editStyleId
                                            )}
                                        >
                                            <ControlLabel>
                                                {Translate('broker-chain/form/edit-style')}
                                            </ControlLabel>
                                            <FormSelect
                                                name="editStyleId"
                                                value={
                                                    this.state.chain.editStyleId
                                                        ? this.state.chain.editStyleId
                                                        : ''
                                                }
                                                onChange={this.formInputChangeHandler.onChange}
                                                defaultTranslateKey="broker-chain/form/edit-style-default-option"
                                            >
                                                {this.props.editStyles.map((x: any) => {
                                                    return (
                                                        <option value={x.id} key={x.id}>
                                                            {x.name}
                                                        </option>
                                                    );
                                                })}
                                            </FormSelect>
                                        </FormGroup>

                                        <FormGroup
                                            validationState={FormValidationService.getValidationState(
                                                this.state.errors.planTemplateId
                                            )}
                                        >
                                            <ControlLabel>
                                                {Translate('broker-chain/form/plan-template')}
                                            </ControlLabel>
                                            <FormSelect
                                                name="planTemplateId"
                                                value={
                                                    this.state.chain.planTemplateId
                                                        ? this.state.chain.planTemplateId
                                                        : ''
                                                }
                                                onChange={this.formInputChangeHandler.onChange}
                                                defaultTranslateKey="broker-chain/form/plan-template-default-option"
                                            >
                                                {this.props.availablePlanTemplates.map((x: any) => {
                                                    return (
                                                        <option value={x.id} key={x.id}>
                                                            {x.name}
                                                        </option>
                                                    );
                                                })}
                                            </FormSelect>
                                            <HelpBlock>
                                                {this.state.errors.planTemplateId}
                                            </HelpBlock>
                                        </FormGroup>
                                    </fieldset>
                                </Tab.Pane>
                                <Tab.Pane eventKey={2}>
                                    <fieldset>
                                        <legend>
                                            {Translate('broker-chain/form/tab/image-size')}
                                        </legend>
                                        <Table hover responsive>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        {Translate('image-size/table/header/name')}
                                                    </th>
                                                    <th>
                                                        {Translate('image-size/table/header/size')}
                                                    </th>
                                                    <th>
                                                        {Translate('image-size/table/header/dpi')}
                                                    </th>
                                                    <th>
                                                        {Translate(
                                                            'image-size/table/header/auto-scale'
                                                        )}
                                                    </th>
                                                    <th>
                                                        {Translate(
                                                            'image-size/table/header/active'
                                                        )}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="label-cell">
                                                        <span className="label label-primary label-table">
                                                            {Translate('image-size/table/high')}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <FormGroup
                                                            validationState={FormValidationService.getValidationState(
                                                                this.state.errors['highImageSize']
                                                            )}
                                                        >
                                                            <FormControl
                                                                name="highImageSize"
                                                                type="number"
                                                                value={
                                                                    this.state.chain.highImageSize
                                                                }
                                                                onChange={
                                                                    this.formInputChangeHandler
                                                                        .onChange
                                                                }
                                                            ></FormControl>
                                                            <HelpBlock>
                                                                {this.state.errors['highImageSize']}
                                                            </HelpBlock>
                                                        </FormGroup>
                                                    </td>
                                                    <td>
                                                        <FormGroup
                                                            validationState={FormValidationService.getValidationState(
                                                                this.state.errors['highImageDpi']
                                                            )}
                                                        >
                                                            <FormControl
                                                                name="highImageDpi"
                                                                type="number"
                                                                value={
                                                                    this.state.chain.highImageDpi
                                                                }
                                                                onChange={
                                                                    this.formInputChangeHandler
                                                                        .onChange
                                                                }
                                                            ></FormControl>
                                                            <HelpBlock>
                                                                {this.state.errors['highImageDpi']}
                                                            </HelpBlock>
                                                        </FormGroup>
                                                    </td>
                                                    <td></td>
                                                    <td className="tools"></td>
                                                </tr>
                                                <tr>
                                                    <td className="label-cell">
                                                        <span className="label label-default label-table">
                                                            {Translate('image-size/table/normal')}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <FormGroup
                                                            validationState={FormValidationService.getValidationState(
                                                                this.state.errors['normalImageSize']
                                                            )}
                                                        >
                                                            <FormControl
                                                                disabled={
                                                                    !this.state.chain
                                                                        .normalImageSizeActive
                                                                }
                                                                name="normalImageSize"
                                                                type="number"
                                                                value={
                                                                    this.state.chain
                                                                        .normalImageSize !==
                                                                    undefined
                                                                        ? this.state.chain
                                                                              .normalImageSize
                                                                        : ''
                                                                }
                                                                onChange={
                                                                    this.formInputChangeHandler
                                                                        .onChange
                                                                }
                                                            ></FormControl>
                                                            <HelpBlock>
                                                                {
                                                                    this.state.errors[
                                                                        'normalImageSize'
                                                                    ]
                                                                }
                                                            </HelpBlock>
                                                        </FormGroup>
                                                    </td>
                                                    <td>
                                                        <FormGroup
                                                            validationState={FormValidationService.getValidationState(
                                                                this.state.errors['normalImageDpi']
                                                            )}
                                                        >
                                                            <FormControl
                                                                disabled={
                                                                    !this.state.chain
                                                                        .normalImageSizeActive
                                                                }
                                                                name="normalImageDpi"
                                                                type="number"
                                                                value={
                                                                    this.state.chain
                                                                        .normalImageDpi !==
                                                                    undefined
                                                                        ? this.state.chain
                                                                              .normalImageDpi
                                                                        : ''
                                                                }
                                                                onChange={
                                                                    this.formInputChangeHandler
                                                                        .onChange
                                                                }
                                                            ></FormControl>
                                                            <HelpBlock>
                                                                {
                                                                    this.state.errors[
                                                                        'normalImageDpi'
                                                                    ]
                                                                }
                                                            </HelpBlock>
                                                        </FormGroup>
                                                    </td>
                                                    <td>
                                                        <Checkbox
                                                            disabled={
                                                                !this.state.chain
                                                                    .normalImageSizeActive
                                                            }
                                                            name="normalImageAutoScale"
                                                            checked={
                                                                this.state.chain
                                                                    .normalImageAutoScale !==
                                                                undefined
                                                                    ? this.state.chain
                                                                          .normalImageAutoScale
                                                                    : false
                                                            }
                                                            onChange={
                                                                this.formInputChangeHandler.onChange
                                                            }
                                                        >
                                                            <span></span>
                                                        </Checkbox>
                                                    </td>
                                                    <td className="tools">
                                                        <Checkbox
                                                            name="normalImageSizeActive"
                                                            checked={
                                                                this.state.chain
                                                                    .normalImageSizeActive
                                                            }
                                                            onChange={
                                                                this.formInputChangeHandler.onChange
                                                            }
                                                        >
                                                            <span></span>
                                                        </Checkbox>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </fieldset>
                                </Tab.Pane>
                                <Tab.Pane eventKey={3}>
                                    <ProductList
                                        availableProductTypes={this.props.availableProductTypes}
                                        availableProducts={this.props.availableProducts}
                                        brokerTreeProductAllocationTypes={
                                            this.props.brokerTreeProductAllocationTypes
                                        }
                                        brokerTreeProductAllocationRequiredOptions={
                                            this.props.brokerTreeProductAllocationRequiredOptions
                                        }
                                        products={this.state.chain.products}
                                        update={this.updateProducts}
                                    />
                                </Tab.Pane>
                                <Tab.Pane eventKey={4}>
                                    <Integrations 
                                        archiveSource={this.state.chain.archiveSource}
                                        availableArchiveSources={this.props.availableArchiveSources}
                                        updateArchiveSource={this.updateArchiveSource}
                                        procountorId = {this.state.chain.procountorId}
                                        onChange = {this.formInputChangeHandler.onChange}
                                        
                                    />
                                </Tab.Pane>
                                <Tab.Pane eventKey={5}>
                                    <ShowcaseSettings
                                        profileColor={this.state.chain.profileColor}
                                        onChange={this.formInputChangeHandler.onChange}
                                        profileLogo={this.state.chain.profileLogo}
                                        updateProfileColor={this.updateProfileColor}
                                        onFileChange={this.handleLogoChange}
                                        imagePreviewUrl={this.state.imagePreviewUrl}
                                        chainId={this.state.chain.id}
                                        firmId={null}
                                    />
                                </Tab.Pane>
                                {showCustomerAgreement && (
                                    <Tab.Pane eventKey={6}>
                                        {this.state.chain.id ? (
                                            <CustomerAgreementTab
                                                customer={{ kind: 'broker-chain', id: this.state.chain.id }}
                                                ref={this.customerAgreementTab}
                                                canAssign={Boolean(
                                                    Features.hasFeature(
                                                        Features.AssignCustomerAgreements,
                                                        this.props.user
                                                    )
                                                )}
                                            />
                                        ) : null}
                                    </Tab.Pane>
                                )}
                            </Tab.Content>
                        </div>
                    </Tab.Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.closeModal}>
                        {Translate('broker-chain/modal/footer/button-label/close')}
                    </Button>
                    <Button disabled={this.state.creating} bsStyle="primary" onClick={this.save}>
                        {Translate('broker-chain/modal/footer/button-label/save')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    addImageSize(property: string) {
        let chain = this.state.chain;
        chain[property] = {};
        this.setChainState(chain);
    }

    deleteImageSize(property: string) {
        let chain = this.state.chain;
        chain[property] = null;
        this.setChainState(chain);
    }

    updateProducts(products: any[]) {
        let chain = assign({}, this.state.chain);
        chain.products = products;
        this.formInputChangeHandler.updateObj(chain);
        this.setChainState(chain);
    }

    updateArchiveSource(e: any) {
        let chain = assign({}, this.state.chain);
        let selectedArchiveValue = this.props.availableArchiveSources.find(x => x.value == e.target.value);
        chain.archiveSource = selectedArchiveValue;
        this.formInputChangeHandler.updateObj(chain);
        this.setChainState(chain);
    }

    save() {
        this.setState({ creating: true });
        if (this.state.chain.id > 0) {
            this.update();
        } else {
            this.create();
        }
    }

    create() {
        this.props.actions
            .createBrokerChain(this.state.chain)
            .then(() => {
                this.setState({ creating: false });
                notify.success(Translate('brokers/chain/create-message'));
                this.closeModal();
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    update() {
        this.props.actions
            .updateBrokerChain(this.state.chain.id, this.state.chain)
            .then(() =>
                this.customerAgreementTab.current
                    ? this.customerAgreementTab.current.save()
                    : true
            )
            .then((customerAgreementSaved: boolean) => {
                this.setState({ creating: false });
                if (customerAgreementSaved) {
                    notify.success(Translate('brokers/chain/edit-message'));
                }
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    closeModal() {
        this.props.onClose();
    }
}

function mapStateToProps(state: any) {
    return {
        user: state.user,
        chain:
            state.brokers && state.brokers.new && state.brokers.new.chain
                ? state.brokers.new.chain || {}
                : state.brokers.edit.chain || {},
        editStyles: Array.isArray(state.brokers.new.editStyles)
            ? state.brokers.new.editStyles
            : Array.isArray(state.brokers.edit.editStyles)
            ? state.brokers.edit.editStyles
            : [],
        availableProductTypes: Array.isArray(state.brokers.new.availableProductTypes)
            ? state.brokers.new.availableProductTypes
            : Array.isArray(state.brokers.edit.availableProductTypes)
            ? state.brokers.edit.availableProductTypes
            : [],
        availableProducts: Array.isArray(state.brokers.new.availableProducts)
            ? state.brokers.new.availableProducts
            : Array.isArray(state.brokers.edit.availableProducts)
            ? state.brokers.edit.availableProducts
            : [],
        products: Array.isArray(state.brokers.new.products)
            ? state.brokers.new.products
            : Array.isArray(state.brokers.edit.products)
            ? state.brokers.edit.products
            : [],
        brokerTreeProductAllocationTypes: Array.isArray(
            state.brokers.new.brokerTreeProductAllocationTypes
        )
            ? state.brokers.new.brokerTreeProductAllocationTypes
            : Array.isArray(state.brokers.edit.brokerTreeProductAllocationTypes)
            ? state.brokers.edit.brokerTreeProductAllocationTypes
            : [],

        brokerTreeProductAllocationRequiredOptions: Array.isArray(
            state.brokers.new.brokerTreeProductAllocationRequiredOptions
        )
            ? state.brokers.new.brokerTreeProductAllocationRequiredOptions
            : Array.isArray(state.brokers.edit.brokerTreeProductAllocationRequiredOptions)
            ? state.brokers.edit.brokerTreeProductAllocationRequiredOptions
            : [],

        availablePlanTemplates: Array.isArray(state.brokers.new.availablePlanTemplates)
            ? state.brokers.new.availablePlanTemplates
            : Array.isArray(state.brokers.edit.availablePlanTemplates)
            ? state.brokers.edit.availablePlanTemplates
            : [],
        availableArchiveSources: Array.isArray(state.brokers.new.archiveSources)
            ? state.brokers.new.archiveSources
            : Array.isArray(state.brokers.edit.archiveSources)
            ? state.brokers.edit.archiveSources
            : []

    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            newBrokerChain: () => dispatch(BrokerChainActions.newBrokerChain()),
            createBrokerChain: (data: any) => dispatch(BrokerChainActions.createBrokerChain(data)),
            editBrokerChain: (id: number) => dispatch(BrokerChainActions.editBrokerChain(id)),
            updateBrokerChain: (id: number, chain: any) =>
                dispatch(BrokerChainActions.updateBrokerChain(id, chain))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChainModal);
